import Actions from './validateContract.actions';

const reducer = (state, action) => {
	const { payload = {} } = action;

	const { year, appointments, contracts, currentContract, team, appointee, validationResult, isLoaded } = payload;

	switch (action.type) {
		case Actions.SET_YEAR:
			return { ...state, year };
		case Actions.SET_APPOINTMENTS:
			return { ...state, appointments, isLoaded };
		case Actions.SET_CONTRACTS:
			return { ...state, contracts };
		case Actions.SET_CURRENT_CONTRACT:
			return { ...state, currentContract, validationResult: null };
		case Actions.SET_TEAM:
			state.currentContract.team = team;
			return { ...state };
		case Actions.SET_APPOINTEE:
			state.currentContract.appointee = appointee;
			return { ...state };
		case Actions.VIEW_PDF:
			return { ...state, viewMain: false, viewPDF: true };
		case Actions.CHECK:
			return { ...state, viewMain: false, viewCheckPDF: true };
		case Actions.CHECKED_PDF:
			state.currentContract.checked += 1;
			return { ...state, viewMain: true, viewPDF: false, viewCheckPDF: false, viewTAndC: false };
		case Actions.CLOSED_PDF:
			return { ...state, viewMain: true, viewPDF: false, viewCheckPDF: false, viewTAndC: false };
		case Actions.VALIDATE_SUCCESS:
			return { ...state, validationResult, appointments, currentContract: null };
		case Actions.VALIDATE_PARTIAL_SUCCESS:
			return { ...state, validationResult, appointments };
		case Actions.VALIDATE_FAIL:
			return { ...state, validationResult };
		case Actions.VIEW_TANDC:
			return { ...state, viewMain: false, viewTAndC: true };
		default:
			return { ...state };
	}
};

export default reducer;
